import { useEffect } from 'react'

import { LocalStorageKey } from 'shared/constants/localStorage'
import { isProd } from 'shared/utils/isProd'
import { lsGetItem } from 'shared/utils/local-storage'

export const AuthCheckPage = () => {
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      // if auth check request is received
      // check if user is logged in and send success message to parent window
      if (event.data.type === 'AUTH_CHECK_REQUEST') {
        const user = lsGetItem(LocalStorageKey.USER)
        if (user && window.parent) {
          ;[
            'https://clusterix.io',
            'https://www.clusterix.io',
            ...(!isProd() ? ['https://testing.clusterix.io'] : [])
          ].forEach(origin => {
            window.parent.postMessage(
              {
                type: 'AUTH_CHECK_SUCCESS',
                data: {
                  name: user.name
                }
              },
              origin
            )
          })
        }
      }
    }

    window.addEventListener('message', handleMessage)

    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [])

  return null
}
